import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-aboutpage-history",
    templateUrl: "./aboutpage-history.component.html",
    styleUrls: ["./aboutpage-history.component.scss"],
})
export class AboutpageHistoryComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}

    sectionTitle: sectionTitleContent[] = [
        {
            subTitle: "UDF Timeline",
            title: "Journey began in 2016",
            paragraphText: "",
        },
    ];
    historyTimeline: TimelineBlock[] = [
        {
            year: "2016",
            date: "",
            title: "Architecture Design",
            paragraphText:
                "Architecture design begins and enterprise principle of “Handle data as an asset” ",
            img: "assets/img/history/img1.jpg",
        },
        {
            year: "2020",
            date: "January 14",
            title: "Kepler usage",
            paragraphText:
                "Upstream Digital Data Foundation using Chemicals architecture (Kepler)",
            img: "assets/img/history/img2.jpg",
        },
        {
            year: "2021",
            date: "March 25",
            title: "Use Case",
            paragraphText: "Upstream Data Foundation by use case (Kepler)",
            img: "assets/img/history/img3.jpg",
        },
        {
            year: "2022",
            date: "December 10",
            title: "Data Entity",
            paragraphText: "Upstream Data Foundation by data entity (Kepler)",
            img: "assets/img/history/img4.jpg",
        },
        {
            year: "2022",
            date: "December 10",
            title: "Global Wells",
            paragraphText:
                "Upstream Data Foundation Roadmap & scale-up Guyana Wells to global Wells",
            img: "assets/img/history/img4.jpg",
        },
        {
            year: "2024",
            date: "December 10",
            title: "Completion",
            paragraphText: "Fully operational Upstream Data Foundation",
            img: "assets/img/history/img4.jpg",
        },
    ];
}
class sectionTitleContent {
    subTitle: string;
    title: string;
    paragraphText: string;
}
class TimelineBlock {
    year: string;
    date: string;
    title: string;
    paragraphText: string;
    img: string;
}
